let scrollTop = 0

const directives = {
  /**
   * 解决当由两层元素时上下的滚动穿透问题
   */
  fixed: {
    bind () {
      scrollTop = document.body.scrollTop || document.documentElement.scrollTop
      document.body.style.cssText += 'position: fixed; width: 100%;'
    },
    unbind () {
      document.body.style.position = ''
      document.body.style.width = ''
      document.body.scrollTop = document.documentElement.scrollTop = Number(scrollTop)
    }
  },

  clickoutside: {
    bind (el, binding, vnode) {
      el.clickCatcher = function (e) {
        console.log(el, e.target)
        if (!(el === e.target || el.contains(e.target))) {
          // 执行绑定的表达式
          vnode.context[binding.expression]()
        }
      }
      window.addEventListener('click', el.clickCatcher)
    },
    unbind: el => {
      window.removeEventListener('click', el.clickCatcher)
      el.clickCatcher = null
    }
  }
}

export default directives
